import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { POD_SIZE_ITEM } from '../../constants/local_storage';
import { trimToTwoDecimals } from '../../utils/trim_to_two_decimals';
import { locationChange } from '../router/actions';
import { POD_IMAGE_ASPECT_RATIO, POD_IMAGE_MARGIN_OFFSET } from './constants';
import type { DisplayAppState, DisplayType, PodSize } from './types';

const width = Number(window.localStorage.getItem(POD_SIZE_ITEM) || 304);
const height = (width - POD_IMAGE_MARGIN_OFFSET) / POD_IMAGE_ASPECT_RATIO;

const initialState: DisplayAppState = {
  display: localStorage.iconikDisplay || 'grid',
  leftNav: false,
  showFullscreenNavPanel: false,
  breakpoint: 4,
  podSize: {
    width,
    height: trimToTwoDecimals(height),
  },
};

export const displaySlice = createSlice({
  name: 'display',
  initialState,
  reducers: {
    setDisplayMode: (state, action: PayloadAction<DisplayType>) => {
      localStorage.setItem('iconikDisplay', action.payload);
      state.display = action.payload;
    },
    toggleLeftNav: (state, action: PayloadAction<boolean>) => {
      state.leftNav = action.payload;
    },
    toggleAssetFullscreenNavPanel: (state, action: PayloadAction<boolean>) => {
      state.showFullscreenNavPanel = action.payload;
    },
    setPodSize: (state, action: PayloadAction<PodSize>) => {
      state.podSize = action.payload;
    },
    breakpointChanged: (state, action: PayloadAction<number>) => {
      state.breakpoint = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(locationChange, (state) => {
      state.leftNav = false;
    });
  },
});

export const {
  setDisplayMode,
  toggleLeftNav,
  toggleAssetFullscreenNavPanel,
  setPodSize,
  breakpointChanged,
} = displaySlice.actions;

export const displayReducer = displaySlice.reducer;
